import { useBulkSignalsInput } from "./utils";
import { ArchivedFilter, AssigneeValue } from "@avenueops/shared-types";
import { DropdownSelect } from "@avenueops/web-components";
import { OvalLoader } from "@avenueops/web-components";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import SetDynamicAssigneeDropdown from "components/SetDynamicAssigneeDropdown";
import Tooltip from "components/generic-building-blocks/Tooltip";
import { iconClassName, iconParentClassName } from "components/workflows/BulkActionButtons";
import { useDeselectAll } from "context/BulkActionsContext";
import React, { useRef, useState } from "react";
import { useOutsideClick } from "utils/hooks";
import { useBulkAssignProcessMutation } from "utils/state/processes";
import { noOp } from "utils/state/utils";

interface Props {
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export default function ProcessTableAssigneeDropdown({ archived, isDashboard }: Props) {
  const deselectAll = useDeselectAll();
  const bulkSignalsInput = useBulkSignalsInput({ archived, isDashboard });
  const [showAssignees, setShowAssignees] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useOutsideClick(dropdownRef, () => setShowAssignees(false));

  const { mutateAsync: bulkAssignMutation, isLoading } = useBulkAssignProcessMutation({
    onSuccess: async () => {
      deselectAll();
    },
  });
  return isLoading ? (
    <div className="ml-2">
      <OvalLoader type="DEFAULT" size={20} />
    </div>
  ) : (
    <>
      <Tooltip text="Assign" justify={"CENTER"} width="FIT" duration="duration-[5ms]">
        <SetDynamicAssigneeDropdown
          assignee={undefined}
          type="ICON"
          mutation={async (value: AssigneeValue) =>
            bulkAssignMutation({
              bulkSignalsInput,
              assigneeInfo: value,
            }).catch(noOp)
          }
        />
      </Tooltip>
    </>
  );
}
